module.exports = __webpack_public_path__ + "img/EA167&168_1-1.32047299.jpg";